import { useState } from 'react'

import {
  cancelTransferCertificate,
  transferCertificate,
  confirmTransferCertificate,
  requestCancelTransferCertificate,
  confirmCancelRequestTransferCertificate,
  rejectCancelRequestTransferCertificate,
  editTransferMetadata,
} from 'store/certificates/actions'
import { ITransferCertificateData } from 'store/certificates/model'
import { useDispatch } from 'store/hooks'

import { MetaData } from 'types'

type UseTransferCertificateResult = {
  isStatusChanged: boolean
  isTransferConfirmed: boolean
  transfer: (payload: ITransferCertificateData) => void
  confirmTransfer: (payload: { certificateId: string }) => void
  cancelTransfer: (payload: { certificateId: string }) => void
  requestCancelTransfer: (payload: { certificateId: string }) => void
  confirmCancelRequestTransfer: (payload: { certificateId: string }) => void
  rejectCancelRequestTransfer: (payload: { certificateId: string }) => void
  editTransfer: (payload: { transferId: string; metadata?: MetaData }) => void
}

export const useTransferCertificate = (): UseTransferCertificateResult => {
  const dispatch = useDispatch()
  const [isStatusChanged, setIsStatusChanged] = useState<boolean>(false)
  const [isTransferConfirmed, setIsTransferConfirmed] = useState<boolean>(false)

  const transfer = (payload: ITransferCertificateData) => {
    dispatch(
      transferCertificate(payload, ({ success }) => {
        success && setIsStatusChanged(!isStatusChanged)
      })
    )
  }

  const cancelTransfer = (payload: { certificateId: string }) => {
    dispatch(
      cancelTransferCertificate(payload, ({ success }) => {
        success && setIsStatusChanged(!isStatusChanged)
      })
    )
  }

  const confirmTransfer = (payload: { certificateId: string }) => {
    dispatch(
      confirmTransferCertificate(payload, ({ success }) => {
        success && setIsTransferConfirmed(true)
      })
    )
  }

  const requestCancelTransfer = (payload: { certificateId: string }) => {
    dispatch(
      requestCancelTransferCertificate(payload, ({ success }) => {
        success && setIsStatusChanged(true)
      })
    )
  }

  const confirmCancelRequestTransfer = (payload: { certificateId: string }) => {
    dispatch(
      confirmCancelRequestTransferCertificate(payload, ({ success }) => {
        success && setIsStatusChanged(true)
      })
    )
  }

  const rejectCancelRequestTransfer = (payload: { certificateId: string }) => {
    dispatch(
      rejectCancelRequestTransferCertificate(payload, ({ success }) => {
        success && setIsStatusChanged(true)
      })
    )
  }

  const editTransfer = (payload: { transferId: string; metadata?: MetaData }) => {
    dispatch(
      editTransferMetadata(payload, ({ success }) => {
        success && setIsStatusChanged(true)
      })
    )
  }

  return {
    isStatusChanged,
    isTransferConfirmed,
    transfer,
    confirmTransfer,
    cancelTransfer,
    requestCancelTransfer,
    confirmCancelRequestTransfer,
    rejectCancelRequestTransfer,
    editTransfer,
  }
}
